const makeHandleCompanyFilterChange = (get) => (e) => {
  const select = e.target
  const companyId = select.value

  const renderedTemplates = document.querySelector(
    `[data-company-id~='${companyId}']`
  )

  if (!renderedTemplates) {
    const url = select.options[select.selectedIndex].dataset.targetUrl

    get(url)
  }
}

export default ($dom, { get, select2 } = {}) => {
  const companyFilter = $dom[0].querySelector(
    'select[data-behavior~="company-filterer"]'
  )

  const handleCompanyFilterChange = makeHandleCompanyFilterChange(get)

  if (companyFilter) {
    select2(companyFilter)

    $dom.on(
      'change',
      '[data-behavior~="company-filterer"]',
      handleCompanyFilterChange
    )
  }

  return () => {
    $dom.off(
      'change',
      '[data-behavior~="company-filterer"]',
      handleCompanyFilterChange
    )
  }
}
